export enum CartItemType {
    /**
     * This is a normal cart item.
     */
    CLASSIC = 0,
    /**
     * This is a gift for the whole cart order.
     */
    GIFT = 1,
    NO_SEND_GIFT = 2,
    /**
     * This is a gift that is related to a product.
     */
    RELATED_GIFT = 3,
    /**
     * This is a configurable product package, where the user can choose the products
     * to include in the package.
     */
    FLEXIBLE_PACKAGE = 4,
    /**
     * This is a package of packages. This package can contain
     * fixed packages or flexible (configurable) packages.
     */
    COMBINABLE_PACKAGE = 5,
    /**
     * This is an item that is a part of a package.
     */
    PACKAGE_ITEM = 6,
    SERVICE = 7,
}

export enum GiftTypeEnum {
    MANUAL = 0,
    AUTOMATIC = 1,
}
